<template>
	<div class="page-container">
		<e-nav :type="0"></e-nav>
        <div class="section-container">
            <div class="inner" v-for="(item, index) in listData" :key="index" v-if="!item['组员']">
                <div class="section">
                    <div class="title">{{item['介绍']}}</div>
                    <div class="content">
                        <div class="icon-info" v-lazy-container="{selector: 'img'}">
                            <img :data-src="item['url'] ? item['url'] : defUrl" :data-error="defUrl" class="img"/>
                        </div>
                        <div class="text-info">
                            <label>{{item['评审姓名']}}</label>
                            <span>{{item['角色']}}</span>
                        </div>
                    </div>  
                </div>
            </div>
            <!-- <div class="inner">
                <div class="section last">
                        <div class="title">评委会主席</div>
                        <div class="content">
                            <div class="icon-info">
                                <img src="" class="img" />
                            </div>
                            <div class="text-info">
                                <label>徐毅</label>
                                <span>评审委员会主席</span>
                            </div>
                        </div>  
                </div>
            </div> -->
        </div>
        <div class="section-container">
            <div class="section">
                    <div class="title">评审及其顾问团队</div>
                    <div class="content" v-for="(item, index) in listData" :key="index" v-if="item['组员']">
                        <div class="icon-info" v-lazy-container="{selector: 'img'}">
                            <img :data-src="item['url'] ? item['url'] : defUrl" :data-error="defUrl" class="img"/>
                            <label>{{item['评审姓名']}}</label>
                            <span>{{item['角色']}}</span>
                        </div>
                        <div class="items">
                            <div class="item" v-for="( section , num ) in item['组员']" :key="num">
                                <label>{{section['评审姓名']}}</label>
                                <span>{{section['角色']}}</span>
                            </div>
                        </div> 
                    </div>  
            </div>
        </div>
	</div>
</template>

<script>
import eNav from '@/components/Nav'
import listData2017 from '@/mock/expert2017'
import listData2018 from '@/mock/expert2018'
import listData2019 from '@/mock/expert2019'


export default {
	name: 'cma_expert',
	components: {
		eNav
	},
	data () { 
		return {
            dataGroup:{
                2017:listData2017,
                2018:listData2018,
                2019:listData2019
            },
            listData: [],
            defUrl: 'http://img01.cmicawards.org.cn/cover/CMADefault.jpg'
        }
	},
	mounted: function() {
        this.listData = this.dataGroup[this.$route.params.id];
        console.log( this.listData)
    },
	methods:{}
}
</script>
<style lang="scss" scoped>
    .section-container {
        padding: 30px 0 20px 0px;
        overflow: hidden;

        .inner {
            float: left;
            width: 50%;

            .section {
                margin-right: 20px;
                &.last {
                    margin-right: 0;
                }
            }
        }
    }
    .section {
        .title{
            font-size: 24px;
            color: #181413;
            line-height: 24px;
        }

        .content{
            position: relative;
            margin-top: 30px;
            padding: 30px;
            background-color: #FBFCFE;

            .icon-info {
                display: table-cell;

                .img {
                    display: inline-block;
                    width: 160px;
                    height: 160px;
                    border-radius: 50%;
                    vertical-align: middle;
                }

                label {
                    display: block;
                    margin-top: 24px;
                    line-height: 24px;
                    font-size: 24px;
                    color: #181413;
                    text-align: center;
                }

                span {
                    display: block;
                    margin-top: 15px;
                    line-height: 14px;
                    font-size: 14px;
                    color: #AAAAAA;
                    text-align: center;
                }
            }

            .text-info {
                padding-left: 30px;
                display: table-cell;
                word-break: break-all;
                vertical-align: middle;

                label {
                    display: block;
                    font-size: 24px;
                    color: #181413;
                    line-height: 24px;
                }

                span {
                    display: block;
                    margin-top: 15px;
                    font-size: 14px;
                    color: #AAAAAA;
                    line-height: 14px;
                }
            }

            .items {
                padding-left: 120px;
                display: table-cell;
                word-break: break-all;
                vertical-align: middle;

                .item {
                    float: left;
                    padding: 20px 0;
                    width: 170px;
                    margin-right: 20px; 

                    label {
                        display: block;
                        font-size: 18px;
                        color: #181413;
                        line-height: 18px;
                    }

                    span {
                        display: block;
                        margin-top: 10px;
                        font-size: 12px;
                        color: #AAAAAA;
                        line-height: 12px;
                    }
                }
            }
        }
    }
</style>

